import React from 'react';
import { Box, Flex } from 'rimble-ui';

function TableTitle() {
	return (
		<div>
			<Flex>
				<Box p={3} width={71 / 100}>
					<label style={{ color: 'white' }}>Receivers</label>
				</Box>
				<Box p={3} width={29 / 100}>
					<label style={{ color: 'white' }}>Amount(USDC)</label>
				</Box>{' '}
			</Flex>
		</div>
	);
}

export default TableTitle;
